import React from "react";
import { Typography } from "@mui/material";
import {
  GridContainer,
  GridItem,
  DataCard,
  DataCardHeader,
  DataCardTitle,
} from "./MonthlyReport.styles";
import { AccountBalance } from "@mui/icons-material";
import { formatDate } from "./MonthlyReport.utils";

const MonthlyReportHeader = ({ reportData }) => {
  const { userType, date, acquirerID, isoID, isoName, merchantID, merchantName, acquirerName } = reportData;

  const getTitle = () => {
    switch (userType) {
      case "acquirer":
        return "Monthly Acquirer Report";
      case "iso":
        return "Monthly ISO Report";
      case "merchant":
        return "Monthly Merchant Report";
      case "admin":
        return "Monthly Admin Report";
      default:
        return "Monthly Consolidated Report";
    }
  };

  return (
    <GridItem xs={12} padding="0 0 15px 0">
      <DataCard>
        <DataCardHeader>
          <AccountBalance color="primary" />
          <DataCardTitle>{getTitle()}</DataCardTitle>
        </DataCardHeader>
        <GridContainer spacing={1} style={{ marginTop: "16px" }}>
          {acquirerID && (
            <GridItem xs={12} sm={6} md={3}>
              <Typography variant="body2" color="text.secondary">
                Acquirer ID
              </Typography>
              <Typography variant="h6">{acquirerID}</Typography>
            </GridItem>
          )}
          {acquirerName && (
            <GridItem xs={12} sm={6} md={3}>
              <Typography variant="body2" color="text.secondary">
                Acquirer Name
              </Typography>
              <Typography variant="h6">{acquirerName}</Typography>
            </GridItem>
          )}
          {isoID && (
            <GridItem xs={12} sm={6} md={3}>
              <Typography variant="body2" color="text.secondary">
                ISO ID
              </Typography>
              <Typography variant="h6">{isoID}</Typography>
            </GridItem>
          )}
          {isoName && (
            <GridItem xs={12} sm={6} md={3}>
              <Typography variant="body2" color="text.secondary">
                ISO Name
              </Typography>
              <Typography variant="h6">{isoName}</Typography>
            </GridItem>
          )}
          {merchantID && (
            <GridItem xs={12} sm={6} md={3}>
              <Typography variant="body2" color="text.secondary">
                Merchant ID
              </Typography>
              <Typography variant="h6">{merchantID}</Typography>
            </GridItem>
          )}
          {merchantName && (
            <GridItem xs={12} sm={6} md={3}>
              <Typography variant="body2" color="text.secondary">
                Merchant Name
              </Typography>
              <Typography variant="h6">{merchantName}</Typography>
            </GridItem>
          )}
          <GridItem xs={12} sm={6} md={3}>
            <Typography variant="body2" color="text.secondary">
              Date of Report
            </Typography>
            <Typography variant="h6">{formatDate(date)}</Typography>
          </GridItem>
        </GridContainer>
      </DataCard>
    </GridItem>
  );
};

export default MonthlyReportHeader;

